<template>
  <el-form ref="tableForm" label-width="0px" :model="tableFormData" :disabled="disabled">
    <div class="text-right mb-10px">
      <el-button type="primary" @click.stop="createRow" size="small">新增</el-button>
    </div>
    <el-table max-height="400px" :data="tableData" border class="w-full" stripe>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="现有管控措施"
        prop="existingControlMehtod"
        show-overflow-tooltip
        min-width="200"
      >
        <template slot="header">
          <span class="text-red-500">*</span>
          现有管控措施
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.uuid}existingControlMehtod`"
            :rules="[
              { required: true, message: '现有管控措施不能为空', trigger: ['blur', 'change'] },
            ]"
          >
            <el-input
              type="textarea"
              :rows="3"
              maxlength="5000"
              show-word-limit
              :placeholder="disabled ? '' : '请输入现有管控措施'"
              v-model="tableFormData[`${scope.row.uuid}existingControlMehtod`]"
              @change="(value) => tableChange(scope.row, value, 'existingControlMehtod')"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        label="管控措施分类1"
        prop="controlMehtodOne"
        show-overflow-tooltip
        width="200"
      >
        <template slot="header">
          <span class="text-red-500">*</span>
          管控措施分类1
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.uuid}controlMehtodOne`"
            :rules="[
              { required: true, message: '管控措施分类1不能为空', trigger: ['blur', 'change'] },
            ]"
          >
            <el-select
              v-model="tableFormData[`${scope.row.uuid}controlMehtodOne`]"
              size="mini"
              clearable
              :placeholder="disabled ? '' : '请输入管控措施分类1'"
              @change="(value) => tableChange(scope.row, value, 'controlMehtodOne')"
            >
              <el-option
                v-for="item in ControlMehtodsOneList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        label="管控措施分类2"
        prop="controlMehtodTwo"
        show-overflow-tooltip
        width="200"
      >
        <template slot="header">
          管控措施分类2
        </template>
        <template slot-scope="scope">
          <el-form-item class="mt-20px" label="" :prop="`${scope.row.uuid}controlMehtodTwo`">
            <el-select
              v-model="tableFormData[`${scope.row.uuid}controlMehtodTwo`]"
              size="mini"
              clearable
              :placeholder="disabled ? '' : '请输入管控措施分类2'"
              @change="(value) => tableChange(scope.row, value, 'controlMehtodTwo')"
            >
              <el-option
                v-for="item in ControlMethodsTwoList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        label="管控措施分类3"
        prop="controlMehtodThree"
        show-overflow-tooltip
        width="200"
      >
        <template slot="header">
          管控措施分类3
        </template>
        <template slot-scope="scope">
          <el-form-item class="mt-20px" label="" :prop="`${scope.row.uuid}controlMehtodThree`">
            <el-select
              v-model="tableFormData[`${scope.row.uuid}controlMehtodThree`]"
              size="mini"
              clearable
              :placeholder="disabled ? '' : '请输入管控措施分类3'"
              @change="(value) => tableChange(scope.row, value, 'controlMehtodThree')"
            >
              <el-option
                v-for="item in ControlMethodsThreeList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        label="建议管控措施"
        prop="suggestControlMehtod"
        show-overflow-tooltip
        min-width="200"
      >
        <template slot-scope="scope">
          <el-input
            type="textarea"
            :rows="3"
            maxlength="5000"
            show-word-limit
            :placeholder="disabled ? '' : '请输入建议管控措施'"
            v-model="scope.row.suggestControlMehtod"
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click.stop="deleteRow(scope.row.uuid)"
            :disabled="disabled || scope.$index === 0"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import { SourcesDangerRecognitionRiskAssessControlApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'

const sourcesDangerRecognitionRiskAssessControlApi = new SourcesDangerRecognitionRiskAssessControlApi()
const uuid = require('uuid')

export default {
  name: 'control-measure',
  props: {
    taskId: {
      type: String,
      default: null,
    },
    identifyId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      default: null,
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      tableFormData: {},
      tableData: [],
      accidentTypeList: [],
      ControlMehtodsOneList: [],
      ControlMethodsTwoList: [],
      ControlMethodsThreeList: [],
      copyTableData: [],
    }
  },
  mounted() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.ControlMehtodsOne',
        'DoublePreventionManagement.DataCategory.ControlMethodsTwo',
        'DoublePreventionManagement.DataCategory.ControlMethodsThree',
      ],
      ['ControlMehtodsOneList', 'ControlMethodsTwoList', 'ControlMethodsThreeList'],
      this
    )
    if (this.identifyId) {
      this.getControlList()
    } else {
      this.tableData = []
    }
  },
  methods: {
    // 获取控制措施列表
    async getControlList() {
      const [err, res] = await sourcesDangerRecognitionRiskAssessControlApi.pagedListQuery({
        maxResultCount: 999,
        skipCount: 0,
        recognitionRelationalId: this.identifyId,
      })
      if (!err) {
        if (res.items && res.items.length > 0) {
          this.tableData = res.items
          this.tableData.forEach((item) => {
            this.$set(item, 'uuid', uuid())
            this.$set(
              this.tableFormData,
              `${item.uuid}existingControlMehtod`,
              item.existingControlMehtod
            )
            this.$set(this.tableFormData, `${item.uuid}controlMehtodOne`, item.controlMehtodOne)
            this.$set(this.tableFormData, `${item.uuid}controlMehtodTwo`, item.controlMehtodTwo)
            this.$set(this.tableFormData, `${item.uuid}controlMehtodThree`, item.controlMehtodThree)
          }, {})
        } else {
          this.tableData = [
            {
              uuid: uuid(),
              controlMehtodOne: null,
              controlMehtodTwo: null,
              existingControlMehtod: null,
              controlMehtodThree: null,
              recognitionRelationalId: this.identifyId,
              sourcesDangerRecognitionPlanTaskId: this.taskId,
            },
          ]
        }
      }
    },
    tableChange(row, value, filed) {
      row[filed] = value || undefined
    },
    validate() {
      let flag
      this.$refs.tableForm.validate((valid) => {
        flag = valid
      })
      return flag
    },
    createRow() {
      this.tableData.push({
        uuid: uuid(),
        controlMehtodOne: undefined,
        controlMehtodTwo: undefined,
        existingControlMehtod: undefined,
        controlMehtodThree: undefined,
        recognitionRelationalId: this.identifyId,
        sourcesDangerRecognitionPlanTaskId: this.taskId,
      })
    },
    deleteRow(id) {
      this.tableData = this.tableData.filter((item) => {
        return item.uuid !== id
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
